module.exports = "/assets/images/ico-zasuvka-2w.883e036f.png";